// Bridges ui.ts's cast handler to GameScene for a Transfer + Momentum cast on a
// pushable object -- unlike Energy/Charge Transfer (which mutates a numeric
// `properties` bag), Momentum's "quantity moved" is a real physical
// displacement: the object slides away from the caster, and the caster
// recoils the same number of tiles in the opposite direction (conservation of
// momentum -- no per-object mass is modeled yet, so this assumes comparable
// effective mass and just moves both the same distance, a deliberate
// simplification, not a claim that every object should recoil identically).
// Always self-sourced regardless of any marked Transfer source -- there's no
// physical sense in which shoving a block draws on some other object's stored
// momentum -- and costs the caster's own Energy, a *different* conserved
// quantity than the Momentum being imparted (muscles burn calories; that's not
// the same bookkeeping as the block-vs-caster momentum balance).
//
// The event/result shapes themselves moved to rune-lab/src/sim/casts.ts with the
// handler that consumes them (2026-07-30, sim extraction step 4b) and are
// re-exported here unchanged, so every import site still reads them from this
// module.
import { MomentumEffectEvent, MomentumEffectResult } from '../../rune-lab/src/sim/casts';

export type { MomentumEffectEvent, MomentumEffectResult };

type Handler = (event: MomentumEffectEvent) => MomentumEffectResult;

let handler: Handler | null = null;

export function onMomentumEffect(fn: Handler): void {
  handler = fn;
}

export function triggerMomentumEffect(event: MomentumEffectEvent): MomentumEffectResult {
  return handler ? handler(event) : { applied: false, tilesRequested: 0, tilesMoved: 0 };
}
